import { styled } from '@mui/material/styles'
import { Box, Typography, Menu } from '@mui/material'
import MuiButton from '../muiButton'

export const Wrapper = styled(Box)(`
  width:100%;
  // max-width:280px;
  // min-width:280px;
`)

export const Heading = styled(Typography)(`
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  background: #F6F6F5;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 100%;
  display: block;
  font-size:14px;
  font-weight: 600;
`)

export const MenuWrapper = styled(Menu)(`
  margin-top:40px;
`)

export const Title = styled(Typography)(`
  margin-top: -10px;
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 20px;
  line-height: 30px;
`)

export const SearchBoxOuterWrapper = styled(Box)(`
  background: #E4EEFB;
  padding: 12px;
  width: 100%;
`)

export const SearchBoxWrapper = styled(Box)(`
  background: #fff;
  border-radius: 4px;
  width: 100%;
  position: relative;
  display: flex;
  padding:8px;

  & .MuiBox-root {
    width: 100%;
  }

  & .MuiOutlinedInput-root, & textarea {
    width: 100%;
    line-height: 20px;
    border: 0;
    min-height: 44px;
    padding: 0;
    &:focus, &:active, &:hover { border: 0; }
  }

  & button {
    min-width: 30px;
  }

  & input {
    font-size: 13px;
    padding-left: 6px;
    width: 220px;
    border: 0;
  }

  & fieldset {
    border: 0;
  }
`)

export const ObservationsWrapper = styled(Box)(`
  position:relative;
  display:inline-block;
  max-height: 400px;

  & .hasData:before {
    content: '';
    position: absolute;
    top: 1px;
    right: 1px;
    width: 8px;
    height: 8px;
    background: #EE2534;
    border-radius: 50%;
    z-index: 2;
  }
`)

export const MuiButtonObservations = styled(MuiButton)(`
  font-weight: 400; // 300;
  width:100%;
  justify-content:space-between;
  color: #fff;
`)

export const ListItemTextWrapper = styled(Box)(`
  max-height: 250px;
  overflow-y: scroll;
  @-moz-document url-prefix() {
    width:calc(100%);
  }

  & span {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #095BBD;
    
    background-image: url("data:image/svg+xml;base64,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");
    background-repeat: no-repeat;
    background-position: -3px -2px;
    padding-left: 18px;
    padding-right: 18px;
  }
  & p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #000000;
    padding-bottom: 15px;
    padding-top: 2px;
    white-space: pre-wrap;
  }
`)

export const CloseWrap = styled(Box)(`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index:3;
`)

export const MenuOuterWrapper = styled(Box)(`
  position: absolute;
  top:40px;
  right: 0;
  z-index:10;
  width: 290px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
  overflow-x:hidden;
  border-radius: 4px;
  
  & .observationCloseButton {
    position: absolute;
    top: 5px;
    right: 7px;
  }
`)

export const ObservationContent = styled(Box)(`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 8px 12px;
  position: relative;  

  & > div{
    width:100%;
  }

  & .deleteIcon {
    width: 22px;
    height: 22px;
    margin-bottom: auto;
    margin-top: 3px;

    position: absolute;
    right: 8px;
    top: 46px;
  }

  &.default .p1{ font-size: 14px; font-weight:400; padding-bottom: 10px; }
  &.default .p2{ font-size: 12px; 
  font-weight: 400; // 300;
  padding-bottom: 30px; }
  &.default .p3{ font-size: 11px; font-weight:400; }

`)

export const ParaLine = styled(Box)(`
  padding: 10px 20px;
  width: calc(100% - 16px);
  font-size: 11px;
  font-weight: 400;
  display: flex;

  &:before, &:after {
    width:50%;
    height:10px;
    content: '';
    border-bottom:1px #E7E7E6 solid;
    margin-right: 10px;
  }
  &:after {
    margin-right: 0;
    margin-left: 10px;
  }
`)
